const QuoteStartReducer = (state = {
    underwritingRecieved: null,
    happyPath: false,
    sessionTimeOut: false,
    customerActivity:{
        startQuoteData: undefined,        
    }
}, action)=>{
    switch(action.type){
        case 'START_QUOTE':
            return {
                ...state,
                quoteStartDetails: action.payload
            }
        case 'LOAD_START_QUOTE_DATA':
            return {
                ...state,
                customerActivity:{
                    startQuoteData: action.payload
                }
            }
        case 'LOAD_PRIMARY_DRIVER':
            return {
                ...state,
                customerActivity:{
                    primaryDriver: action.payload
                }
            }
        case 'RECEIVED_TOKEN':
            return{
                ...state,
                token: action.payload
            }
        case 'RETRIEVING_TOKEN':
            return{
                ...state
            }
        case 'REQUESTING_UNDERWRITING':
            return{
                ...state
            }
        case 'RECEIVED_UNDERWRITING':
        return{
            ...state,
            underWriting: action.payload
            }
        case 'RECEIVED_UNDERWRITING_ERROR':
        return{
            ...state,
            error: action.payload
            }
        case 'SAVE_POLICYHOLDER_NAME':
            return{
                ...state,
                policyHolderName: action.payload
            }
        case 'LOAD_FORM':
            return{
                ...state,
                testData: action.payload
            }
        case 'SET_HAPPY_PATH':
            return {
                ...state,
                happyPath: action.payload
            }
        case 'SESSION_TIMEOUT':
            return {
                ...state,
                sessionTimeOut: true
            }
        default:
            return {
                ...state
            }
    }
}

export default QuoteStartReducer;


// WEBPACK FOOTER //
// ./src/StartQuote/reducers.js